
import React from "react";
import ContentLoader from "react-content-loader";

const ProductSkeleton = (props) => (
  <div>
    <ContentLoader
      speed={2.2}
      width="100%"
      height={50}
      viewBox="0 0 700 60"
      backgroundColor="#f0f0f0"
      foregroundColor="#e0e0e0"
      style={{
        borderRadius: "8px",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
      }}
      {...props}
    >
      {/* Imagen redonda más pequeña */}
      <circle cx="35" cy="35" r="25" />

      {/* Título del producto */}
      <rect x="65" y="20" rx="3" ry="3" width="420" height="16" />

      {/* Subtítulo del producto */}
      <rect x="65" y="40" rx="3" ry="3" width="100" height="12" />
      
    </ContentLoader>
  </div>
);

export default ProductSkeleton;
